function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { HStack, Pressable, Text } from 'native-base';
import React, { memo } from 'react';
import { useOfferCardContext } from '../../../context';
import { Linking } from 'react-native';
import { CaretRightIcon } from '../../../../assets';
import { Typography } from '../Typography';
import { Functions } from '../../../../index';
const CTALink = _ref => {
  let {
    content,
    metadata: {
      href,
      ...rest
    },
    event: {
      action
    } = {
      action: 'CTALinkClicked'
    }
  } = _ref;
  const {
    logUserEvent,
    cardType
  } = useOfferCardContext() || {
    cardType: ''
  };
  return /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => {
      //@ts-ignore
      const [{
        content
      }] = Functions.textReplacer(href, rest.values);
      if (content) Linking.canOpenURL(content).then(async () => {
        await Linking.openURL(String(content).trim());
      });
      logUserEvent({
        action: action,
        type: cardType,
        description: `${action} - ${cardType}`
      });
    }
  }, _ref2 => {
    let {
      isHovered
    } = _ref2;
    return /*#__PURE__*/React.createElement(HStack, {
      space: "3",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement(Text, _extends({
      color: isHovered ? 'darkblue.800' : 'primary.400',
      fontSize: "lg",
      fontWeight: "medium",
      lineHeight: '21',
      testID: `${cardType}${content}`,
      accessibilityLabel: content,
      accessibilityRole: "text"
    }, rest), /*#__PURE__*/React.createElement(Typography, {
      fontSize: "lg",
      fontWeight: "medium",
      metadata: {
        href,
        ...rest
      },
      content: content
    })), /*#__PURE__*/React.createElement(CaretRightIcon, {
      color: isHovered ? '#095cd4' : '#0A4A8D'
    }));
  });
};
export default /*#__PURE__*/memo(CTALink);
//# sourceMappingURL=CTALink.js.map